<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.goodsName" placeholder="请输入商品名称"></el-input>
				</el-form-item>				
				<el-form-item  label="一级分类" label-width='70px'>
					<el-select clearable @change='selectClassGoodsType' v-model="secah.goodsTypeOneId" placeholder="请选择一级分类">
						<el-option v-for="item in classGoodsType" :key="item.goodsTypeId" :label="item.goodsTypeName" :value="item.goodsTypeId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="二级分类" label-width='70px'>
					<el-select clearable v-model="secah.goodsTypeTwoId" placeholder="请选择二级分类">
						<el-option v-for="item in leveGoodsType" :key="item.goodsTypeId" :label="item.goodsTypeName" :value="item.goodsTypeId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="供货商" label-width='60px'>
					<el-select clearable v-model="secah.supplierId" placeholder="请选择供货商">
						<el-option v-for="item in supplier" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="是否热销" label-width='70px'>
					<el-select clearable v-model="secah.isHotSale" placeholder="请选择">
						<el-option  label="是" value="1">
						</el-option>
						<el-option  label="否" value="2">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="是否上架" label-width='70px'>
					<el-select clearable v-model="secah.isOnShelf" placeholder="请选择">
						<el-option  label="是" value="1">
						</el-option>
						<el-option  label="否" value="2">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="今日上新" label-width='70px'>
					<el-select clearable v-model="secah.isTodayShelf" placeholder="请选择">
						<el-option  label="是" value="1">
						</el-option>
						<el-option  label="否" value="2">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click='resetClick'>重置</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div>
			<el-table :data="tableData" style="width: 100%" border >
				<!-- <el-table-column fixed="left" type="selection" width="35">
				</el-table-column> -->
				<el-table-column prop="goodsName" label="商品名称" align="center">
				</el-table-column>
				<el-table-column prop="goodsNowPrice" label="商品现价" align="center">
				</el-table-column>
				<el-table-column prop="goodsOrgPrice" label="商品原价" align="center">
				</el-table-column>
				<el-table-column prop="goodsTypeOneName" label="一级分类名称" align="center">
				</el-table-column>
				<el-table-column prop="goodsTypeTwoName" label="二级分类名称" align="center">
				</el-table-column>
				<el-table-column prop="goodsTypeThreeName" label="三级分类名称" align="center">
				</el-table-column>
				<el-table-column prop="monthlySales" label="月销量" align="center">
				</el-table-column>
				<el-table-column prop="pageViews" label="浏览量" align="center">
				</el-table-column>
				<el-table-column prop="supplierName" label="供货商名称" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="330" align="center">
					<template slot-scope="scope">
						<el-button size="mini" v-if="scope.row.isOnShelf==2" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" v-if="scope.row.isOnShelf==2" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="success" @click="isPut(scope.row,1)" v-if="scope.row.isOnShelf==2">上架
						</el-button>
						<el-button size="mini" type="warning" @click="isPut(scope.row,2)" v-else>下架</el-button>
						<el-button size="mini" type="success" @click="isHot(scope.row,1)" v-if="scope.row.isHotSale==2">设置热销
						</el-button>
						<el-button size="mini" type="warning" @click="isHot(scope.row,2)" v-else>取消热销</el-button>
						<div style="height: 10px;width: 100%;" v-if="scope.row.isOnShelf==2"></div>
						
						<el-button size="mini" type="success" @click="isNew(scope.row,1)" v-if="scope.row.isTodayShelf==2">设置今日上新
						</el-button>
						<el-button size="mini" type="warning" @click="isNew(scope.row,2)" v-else>取消今日上新</el-button>
						<el-button size="mini" type="primary" v-if="scope.row.isOnShelf==2" @click="attribute(scope.row)">设置属性</el-button>
						<el-button size="mini" type="primary" v-if="scope.row.isOnShelf==2" @click="setPrice(scope.row)">设置单品</el-button>
						
						
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="10"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		
		
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' v-if="dialogVisible" :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="800px">
			<addGoods @closeMoule="closeMoule" :isAdd="isAdd" :goodsId='goodsId'></addGoods>
		</el-dialog>
		
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' v-if="attributeDialogVisible" title="设置属性" :visible.sync="attributeDialogVisible" :modal-append-to-body='false' width="60%">
			<attribute :goodsId='goodsId' @closeMoule="closeMoulEattribute"></attribute>
		</el-dialog>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' v-if="setPriceDialogVisible" title="设置单品价格" :visible.sync="setPriceDialogVisible" :modal-append-to-body='false' width="60%">
			<setPrice :goodsId='goodsId' @closeMoule="closeMouleSetPrice"></setPrice>
		</el-dialog>
		
	</div>
</template>

<script>	
	import addGoods from './components/add.vue'
	import attribute from './components/attribute.vue'
	import setPrice from './components/setPrice.vue'
	export default {
		components: {
			addGoods,
			attribute,
			setPrice
		},
		data() {
			return {
				webUrl:this.webUrl,
				webImgUrl:this.webImgUrl,
				headers:{
					'token':this.$store.state.token,
					'Content-Type': 'multipart/form-data'
				},			
				tableData: [],				
				dialogVisible: false,
				isAdd: true,
				total: 0,
				secah: {
					goodsName: "",
					goodsTypeOneId: "",
					goodsTypeTwoId: "",
					isHotSale: "",
					isOnShelf: "",
					isTodayShelf: "",
					pageNum: 1,
					pageSize: 10,
					supplierId: ""
				},				
				supplier:[],
				classGoodsType:[],
				leveGoodsType:[],
				goodsId:"",
				attributeDialogVisible:false,
				setPriceDialogVisible:false

			}
		},
		mounted() {
			this.getAllSupplier()
			this.getGoodsType()
			this.getGoodsList()
		},
		methods: {
			//关闭新增修改回调
			closeMoule(e){
				this.dialogVisible=false
				if(e){
					this.getGoodsList()
				}
				
			},
			//关闭设置属性回调
			closeMoulEattribute(){
				this.attributeDialogVisible=false
				// this.getGoodsList()
			},
			//关闭设置价格回调
			closeMouleSetPrice(){
				this.setPriceDialogVisible=false
				// this.getGoodsList()
			},
			//搜索
			secahClick() {
				this.secah.pageNum=1
				this.getGoodsList()
			},
			//重置
			resetClick(){
				this.secah= {
					"goodsName": "",
					"goodsTypeOneId": '',
					"goodsTypeTwoId": '',
					"isHotSale": '',
					"isOnShelf": '',
					"isTodayShelf": '',
					"pageNum": 1,
					"pageSize": 10,
					"supplierId": ''
				},
				this.getGoodsList()	
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
			},
			//设置上架
			isPut(row,isOnShelf) {
				this.httpPut("/goods/changeShelf?"+this.$qs.stringify({
						goodsId: row.goodsId,
						isOnShelf: isOnShelf
					})).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
						row.isOnShelf=isOnShelf
					}
				})
			},						
			//设置上新
			isNew(row,isTodayShelf) {
				this.httpPut("/goods/changeTodayShelf?"+this.$qs.stringify({
						goodsId: row.goodsId,
						isTodayShelf: isTodayShelf
					})).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
						row.isTodayShelf=isTodayShelf
					}
				})
			},
			//设置热销
			isHot(row,isHotSale) {
				this.httpPut("/goods/changeHotSale?"+this.$qs.stringify({
						goodsId: row.goodsId,
						isHotSale: isHotSale
					})).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
						row.isHotSale=isHotSale
					}
				})
			},
			//设置属性
			attribute(row){
				this.goodsId=row.goodsId
				this.attributeDialogVisible=true
			},		
			//设置单品价格
			setPrice(row){
				this.goodsId=row.goodsId
				this.httpPost("/goods/getAttr?" + this.$qs.stringify({
					goodsId: this.goodsId
				})).then(res => {
					if (res.code == 200) {						
						if(res.data.length>0){
							
							this.setPriceDialogVisible=true
						}else{
							this.$message.error("请先设置属性")
						}
					}
				})
			},
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/goods/del?" + this.$qs.stringify({
						goodsId: row.goodsId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getGoodsList()
						}
					})
				}).catch(() => {});
			},
			//修改
			edit(row) {
				// console.log(row);
				this.goodsId=row.goodsId
				this.dialogVisible = true
				this.isAdd = false
			},
			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getGoodsList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getGoodsList()
			},		
			//获取商品列表
			getGoodsList() {
				var obj={}
				for(var key in this.secah){
					if(this.secah[key]){
						obj[key]=this.secah[key]
					}
				}
				obj.pageNum=obj.pageNum+''
				obj.pageSize=obj.pageSize+''
				this.httpPost("/goods/listByPage", obj, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})
			
			},			
			//获取供货商
			getAllSupplier(){
				this.httpPost("/supplier/allSupplier").then(res => {
					if (res.code == 200) {
						this.supplier=res.data
					}
				})
			},			
			//获取一级分类
			getGoodsType() {
				this.httpPost("/goodsType/allFirstGoodsType").then(res => {
					if (res.code == 200) {
						this.classGoodsType = res.data
					}
				})
			},
			//选择一级分类
			selectClassGoodsType(e){
				this.leveGoodsType=[]
				this.secah.goodsTypeTwoId=''
				this.getleveGoodsType(e)
			},
			//获取二级分类
			getleveGoodsType(id) {
				this.httpPost("/goodsType/getGoodsTypeByParentId?"+this.$qs.stringify({
						goodsTypeId: id
					})).then(res => {
					if (res.code == 200) {
						this.leveGoodsType = res.data
						// if(res.data.length==0){
						// 	// this.form.goodsTypeOneId=""
						// 	this.$message('请重新选择一级分类');
						// }
					}
				})
			},
					
		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	::v-deep .ql-editor{
		height: 300px !important;
	}
	/* ::v-deep .el-dialog {
	    margin: 4% auto auto auto !important;
	    max-height: 80vh;
		min-height: 80vh;
	    .el-dialog__body {
	      position: absolute;
	      left: 0;
	      top: 54px;
	      bottom: 0;
	      right: 0;
	      padding: 0;
	      z-index: 1;
	      overflow: hidden;
	      overflow-y: auto;
	      box-sizing: border-box;
	　　　　
	      &::-webkit-scrollbar {
	        width: 2px;
	        background-color: #ccc;
	      }
	      &::-webkit-scrollbar-thumb {
	        background-color: #0ae;
	      }
	      &::-webkit-scrollbar-track {
	        background-color: #ccc;
	      }
	    }
	  } */
	  
</style>
